'use client';

import { useEffect } from 'react';

export default function ScrollRevealInit() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px',
      }
    );

    // Observe all .reveal-blur elements
    document.querySelectorAll('.reveal-blur')?.forEach((el) => {
      observer?.observe(el);
    });

    // Observe stagger containers
    document.querySelectorAll('.stagger-children')?.forEach((container) => {
      const childObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.querySelectorAll('.reveal-blur').forEach((child, i) => {
                setTimeout(() => child.classList.add('is-visible'), i * 100);
              });
              childObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      childObserver?.observe(container);
    });

    return () => observer?.disconnect();
  }, []);

  return null;
}